import { render } from "./TestPage.vue?vue&type=template&id=0d3de421&ts=true"
import script from "./TestPage?vue&type=script&lang=ts"
export * from "./TestPage?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__